// extracted by mini-css-extract-plugin
module.exports = {"disclaimerContent":"_1WxHiI6r","disclaimerIcon":"_2s8_jjkb","subtitle":"_2NZ9pfgG","itemCount":"W0cN7446","warningOption":"_3NXKIPH0","warningOptionLabel":"_3tJnRi0J"};